import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid, makeStyles } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(() => ({
  accordion: {
    border: '1px solid #E4E7EC',
    borderRadius: '8px',
    marginBottom: '16px',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
  },
  accordionSummary: {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    flexDirection: 'row-reverse',
    padding: '0px',
    '& .MuiAccordionSummary-expandIcon': {
      marginRight: 0,
      marginLeft: 0,
    },
    '& .MuiAccordionSummary-content': {
      marginLeft: 0,
    },
    '&.Mui-expanded': {
      minHeight: '56px',
    },
  },
  accordionDetails: {
    borderTop: '1px solid rgba(0, 0, 0, 0.125)',
  },
  title: {
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '19.6px',
    color: '#10182B',
  },
  inputField: {
    width: '98%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: 'white',
    fontSize: '14px',
  },
  requiredField: {
    color: '#667085',
    fontSize: '14px',
    marginBottom: '5px',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  richTextContainer: {
    marginTop: '5px',
  },
  textArea: {
    width: '98%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: 'white',
    fontSize: '14px',
    fontFamily: 'inherit',
    resize: 'vertical',
    minHeight: '100px',
  },
}));

const ScoringParameterCard = ({ data, index, handleChange }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(index === 0);

  const handleAccordionChange = () => (event, isExpanded) => {
    setExpanded(isExpanded);
  };

  const handleFieldChange = (field, value) => {
    handleChange(index, field, value);
  };

  const handleInstructionsChange = ({ target: { value: textContent } }) => {
    const instructions = textContent.split('\n').map((line) => line.trim());

    // Update instructions array
    handleChange(index, 'instructions', instructions);
  };

  // Convert instructions array to string for display in textarea
  const getInstructionsText = () => {
    if (data?.instructions && Array.isArray(data.instructions) && data.instructions.length > 0) {
      // Convert array of strings to plain text with newlines
      return data.instructions.join('\n');
    }
    return '';
  };

  return (
    <Accordion expanded={expanded} onChange={handleAccordionChange(`panel${index}`)} className={classes.accordion}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel${index}-content`}
        id={`panel${index}-header`}
        className={classes.accordionSummary}
      >
        <Typography className={classes.title}>{data?.name || `Scoring Parameter ${index + 1}`}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography className={classes.requiredField}>Parameter Name</Typography>
            <input
              className={classes.inputField}
              placeholder="e.g., Introduction"
              value={data?.name || ''}
              onChange={(e) => handleFieldChange('name', e.target.value)}
            />
          </Grid>
          <Grid item>
            <Typography className={classes.requiredField}>Parameter Description</Typography>
            <input
              className={classes.inputField}
              placeholder="e.g., How well the user introduces themselves"
              value={data?.description || ''}
              onChange={(e) => handleFieldChange('description', e.target.value)}
            />
          </Grid>
          <Grid item>
            <Typography className={classes.requiredField}>Scoring Logic</Typography>
            <div className={classes.richTextContainer}>
              <textarea
                className={classes.textArea}
                placeholder="Enter scoring logic instructions (one per line)"
                value={getInstructionsText()}
                onChange={handleInstructionsChange}
              />
            </div>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default ScoringParameterCard;
